import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import { ArrowLeft } from 'lucide-react';

const Impressum = ({ user, onLogout }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar user={user} onLogout={onLogout} />
      
      <div className="pt-24 pb-12 px-4">
        <div className="max-w-4xl mx-auto">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-gray-600 hover:text-[#2B2142] mb-6"
          >
            <ArrowLeft className="w-5 h-5" />
            Zurück
          </button>

          <div className="bg-white rounded-3xl shadow-lg p-4 sm:p-6 md:p-12">
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-8 break-words">Impressum</h1>

            <div className="space-y-8 text-gray-700 leading-relaxed break-words">
              <section>
                <h2 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-4">Angaben gemäß § 5 TMG</h2>
                <p className="mb-2"><strong>EventConnect GmbH</strong></p>
                <p>Hauptstätter Straße 112</p>
                <p>70178 Stuttgart</p>
                <p>Deutschland</p>
                <p className="mt-4">Amtsgericht Stuttgart</p>
                <p>HRB 776828</p>
                <p className="mt-2">Steuernummer: 99147/00876</p>
              </section>

              <section>
                <h2 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-4">Kontakt</h2>
                <p>E-Mail: <a href="mailto:kontakt@evconn.de" className="text-[#2B2142] hover:underline">kontakt@evconn.de</a></p>
              </section>

              <section>
                <h2 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-4">EU-Streitschlichtung</h2>
                <p>Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:</p>
                <p><a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#2B2142] hover:underline break-all">https://ec.europa.eu/consumers/odr/</a></p>
                <p className="mt-2">Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
              </section>

              <section>
                <h2 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-4">Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
                <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
              </section>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Impressum;
